import React, { Component } from 'react';
import $ from 'jquery';
import ReactDOM from 'react-dom';
import Vas from '../../../Vas';

import '../../../css/DocumentUpload.css';
import { ExtendedButton,TextField,Icon,MessageBox } from 'component-lib';
import { DocumentsModel, RequestAjaxClass} from 'models-lib';

class CustomerDocumentUpload extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.files='';
        this.state.fileName='';
        this.state.reference=this;
        this.state.filled = false;
        this.CustomerId = localStorage.getItem('employee_id') ? localStorage.getItem('employee_id'):localStorage.getItem("vas_customerId");
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.DocumentsModel = new DocumentsModel([this], null, this.Request);
        
        this.FileText = React.createRef();

        this.IconConfig = Vas.Config.ShowIconsOrButtons;

        this.UploadConfig = Vas.Config.DocumentUpload;
    }
    
    componentDidMount(){
      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setAuth(true);
      this.Request.setErrorHandler((data)=>{
        $("#LoadingIcon").removeClass().addClass('hide');
      });

      this.DocumentsModel.GetFileParamsByCustomerId(this.CustomerId);

      this.LogoClick();
    }

    FileUpload() {
        if (this.state.filled === true){
            $("#LoadingIcon").removeClass().addClass('loaderSmall');
            this.DocumentsModel.UploadDocument(this.CustomerId,this.state.files);
        }
    }

    Update(observer)
    {
        this.setState({},()=>{
          if(observer === "UploadDocument"){
            $("#LoadingIcon").removeClass().addClass('hide');
            if(this.DocumentsModel.UploadSuccess === true){
              $("#LoadingIcon").removeClass().addClass('hide');
              Vas.GetView("CustomerDocumentUploadSuccess", {CustomerId:this.CustomerId}, true);
            }else{
              ReactDOM.render(<MessageBox 
                AppURL={Vas.ApplicationUrl} 
                Message={Vas.Resources.ErrorMessages["UnexpectedError"]} 
                Title={Vas.Resources.Titles["Note"]} />
                  , document.getElementById('messageContainer'));
            }
          }
        });
    }

    Cancel(){
        this.props.me.setState({ Upload:false });
    }

    storeFile(event){
        let type = event.target.files[0].type;
        
        if (((type.slice(0,5) === "image") || (type === "application/pdf")) && (event.target.files[0].size > 0) ){

          let maxFileSize = 10 * 1024 * 1000;

              if (event.target.files[0].size > maxFileSize){
                ReactDOM.render(<MessageBox 
                  AppURL={Vas.ApplicationUrl} 
                  Message={Vas.Resources.Labels["DocumentSizeInvalid"]} 
                  Title={Vas.Resources.Titles["Note"]} />
                    , document.getElementById('messageContainer'));

                    this.refs.FileText.setState({ Value:'', TextTooltip : '' });
                    this.setState({ filled:false });
              } else {
                let original = event.target.files[0].name;
                let name = event.target.files[0].name.split(".");
     
                if(name.length === 2){
                  let length = name[0].length;
                  let showName = name[0];
                  let showType = "." + name[1];
                  if(length > 20){
                   showName = name[0].substr(0,19) + "...";
                  }
                  original = showName + showType;
                }
                
                if(this.UploadConfig.ShowStandardControl === false){
                   this.refs.FileText.setState({ Value:original, TextTooltip : event.target.files[0].name });
                }
                
                this.setState({ files:event.target.files, fileName:event.target.files[0].name },()=>{ 
                     if (this.state.fileName.length>0){
                         //this.refs.btoDone.setState({usable:true});
                         this.setState({ filled:true });
                     } else {
                         //this.refs.btoDone.setState({usable:false});
                         this.setState({ filled:false });
                     }
                 }); 
              }
          
        }else{
          if(event.target.files[0].size === 0){
            ReactDOM.render(<MessageBox 
              AppURL={Vas.ApplicationUrl} 
              Message={Vas.Resources.Labels["FileNoContent"]} 
              Title={Vas.Resources.Titles["Note"]} />
                , document.getElementById('messageContainer'));
          }
        }
    }

    Close(){
        Vas.GetView("CustomerCard",{Id:this.CustomerId},true);
    }

    LogoClick(){

      var kontrastNumber = localStorage.getItem('Kontrast');
  
      if(kontrastNumber == "true"){
        $('.documentUploadForm').attr('style', 'border: 1px solid #1d5c87;');
        $('#FileText').attr('style', 'width: 300px; float: left; border-bottom: 1px dotted #1d5c87;');
        $('.documentUploadForm #btoChoose').attr('style', 'background-color: #1d5c87; width: 150px;');
        $('.documentUploadForm #btoFileUpload').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
        $('.documentUploadForm #btoCancel').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
      }
    }

    render()
    {

      let btoChooseIcon = <ExtendedButton
                    Id={"btoChoose"}
                    Usable={true}
                    Text={<Icon
                      Name={"Upload"}
                      Size={18}
                      Color={"black"}
                      PaddingLeft={'6px'}
                      PaddingTop={'0px'}
                      Tooltip={Vas.Resources.Tooltips["ChooseDocument"]} />}
                    Width={30}
                    Height={30}
                    Type={"Round"}
                    OnClick={()=>{$("#fileUpload").trigger('click');}} />;

      if(Vas.isIE) {
        btoChooseIcon = <ExtendedButton
          Id={"btoChoose"}
          Usable={true}
          Text={<Icon
          Name={"Upload"}
          Size={18}
          Color={"black"}
          PaddingLeft={'6px'}
          PaddingTop={'0px'}
          Tooltip={Vas.Resources.Tooltips["ChooseDocument"]} />}
          Width={30}
          Height={30}
          Type={"Round"}/>;
      }
      
      let btoChooseText = "";
      if(this.IconConfig.ShowIcons === false){
        btoChooseIcon="";
        btoChooseText = <ExtendedButton
          Id={"btoChoose"}
          Usable={true}
          Text={Vas.Resources.Labels["ChooseDocument"]}
          Width={150}
          OnClick={()=>{$("#fileUpload").trigger('click');}} />;

        if(Vas.isIE) {
          btoChooseText = <ExtendedButton
            Id={"btoChoose"}
            Usable={true}
            Text={Vas.Resources.Labels["ChooseDocument"]}
            Width={150} />;
        }
      }

      let classNameStandartControl = "standartInput";
      let additionTextField = <td></td>;
      let additionButton = <td></td>;

      if(this.UploadConfig.ShowStandardControl === false){
        classNameStandartControl = "inputfile";
        additionTextField = <td>
        <TextField
          ref={"FileText"}
          AppURL={Vas.ApplicationUrl}
          Width={300}
          Id="FileText"
          Value={this.state.fileName}
          Editable={false}
          Label={Vas.Resources.Labels["File"]}
          Float={"left"} />
          
      </td>;
        additionButton = <td colSpan={2}>
        <label htmlFor="fileUpload">
            {btoChooseText}
            
            </label>
        </td>;
      }


        return (
        <div className={"form documentUploadForm"}>
          <table ref="table" >
            <thead>
              <tr>
                <th colSpan={2}>{Vas.Resources.Labels["UploadDocument"]}</th>
                <th><div
                          id={"LoadingIcon"}
                          className={'hide'}></div></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
               
                  <input
                    id="fileUpload"
                    name="fileUpload"
                    type="file"
                    className={classNameStandartControl}
                    onChange={(event)=>{this.storeFile(event);}}
                    accept="image/bmp,image/png,image/jpeg,image/jpg, image/gif,application/pdf" />
                  <label htmlFor="fileUpload">
                   
                    {btoChooseIcon}
                    </label>
                </td>
                {additionTextField}
                <td>
                
                </td>
              </tr>
              <tr>
                {additionButton}
              </tr>
              <tr>
                <td colSpan={2}>
                  <div id={"documentUploadHintContainer"}>
                    <br />{Vas.Resources.Labels["ValidDocumentFormat"]}
                    <br /><br /> {Vas.Resources.Labels["ValidDocumentSize"]}
                  </div>
                </td>
              </tr>
              
            </tbody>
          </table>
          <table>
            <tbody>
            <tr>
                <td >
                  <br /><ExtendedButton
                    Id={"btoFileUpload"}
                    Usable={true}
                    ref={"btoDone"}
                    Text={Vas.Resources.Labels["UploadCertificate"]}
                    Float={'left'}
                    OnClick={()=>{ this.FileUpload();}}
                    Width={170}
                    />
                </td>
                <td>   
                  <br /><ExtendedButton
                    Id={"btoCancel"}
                    Usable={true}
                    Text={Vas.Resources.Labels["Cancel"]}
                    Float={'left'}
                    OnClick={()=>{ this.Close();}}
                    Width={170}
                   />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        );
    }
}
export default CustomerDocumentUpload;
